import React, { useEffect, useState, useReducer } from 'react';
import './style.scss';
import Ticker from '../../components/autonomicTicker';
import { ResultProvider } from '../../dataProvider/results/index';
import { TYPES, SUBTYPES } from '../../envs/core';
import usePlaceProvider from '../../dataProvider/hooks/usePlaceProvider';
const REGIONS = [
  'R02',
  'R03',
  'R04',
  'R05',
  'R06',
  'R07',
  'R08',
  'R10',
  'R11',
  'R13',
  'R14',
  'R15',
  'R17'
];

const INITIAL_STATE = { currentRegion: 0 };
const reducer = (state, action) => {
  if (action.type === 'changeRegion') {
    return { currentRegion: (state.currentRegion + 1) % REGIONS.length };
  }
};

const TickerContainer = () => {
  const [renderFlag, setRenderFlag] = useState(true);
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const place = usePlaceProvider(REGIONS[state.currentRegion]);

  useEffect(() => {
    const interval = setInterval(() => {
      setRenderFlag(false);
      setTimeout(() => {
        dispatch({ type: 'changeRegion' });
      }, 10);
      setTimeout(() => {
        setRenderFlag(true);
      }, 40);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="ticker-wrapper">
      <ResultProvider
        electionPlace={REGIONS[state.currentRegion]}
        active={true}
        year={2019}
        type={TYPES.REGIONAL}
        subtype={SUBTYPES.SINGLE}
        electionNumber={1}
        placeId={REGIONS[state.currentRegion]}
      >
        {results => {
          return renderFlag ? (
            <Ticker place={place} results={results.partiesResult} />
          ) : null;
        }}
      </ResultProvider>
    </div>
  );
};

export default TickerContainer;
